const projects = [
  {
    icon: require("./football.jpg"),
    name: "Football Manager website",
    description: [
      "Developed a PHP and MySQL-powered web application for efficient football team management. Implemented user registration, login, dynamic team creation, editing, and deletion features. Demonstrated full-stack development skills",
    ],
  },
  {
    icon: require("./instagram.jpg"),
    name: "Instagram clone",
    description: [
      "Programmed a clone of Instagram’s home page with beautiful design and animation using React, CSS, and JS",
    ],
  },
  {
    icon: require("./Sudoku.png"),
    name: "Sudoku Solver",
    description: [
      "Implemented a Sudoku solver in Java and JavaScript, which can solve any valid Sudoku puzzle by applying logical deduction rules and designed a web page for it.",
    ],
  },
  {
    icon: require("./fullstack.webp"),
    name: "full stack application",
    description: [
      "implemented multiple simple full stack applications in Python and in node js, the server responsible for responding to calls from the client and from the browser with the requested web pages or with other messages",
    ],
  },

  {
    icon: require("./snake.jpg"),
    name: "Snake Game",
    description: [
      "Programmed a snake-like game in Java using object-oriented programming principles, which includes features like score tracking sound effects and computer-controlled player",
    ],
  },
  {
    icon: require("./graduation.jpg"),
    name: "Graduation Project",
    description: [
      " Led a team of 3 students in developing an air pollution measurement system as a part of the graduation project using Arduinos and Raspberry Pi with wireless communication. ",
      " Developed a user-friendly GUI for the Raspberry Pi using Python, enabling users to view and analyze different sensor readings through interactive charts based on selected time ranges (day, week, month, year, or live data). ",
      " Created a cross-platform mobile application for Android and iOS using React Native, with similar functionality to the Raspberry Pi GUI app for data visualization and analysis.",
    ],
  },
];

const About = "";

const skills = [
  "Diligent Work Ethic",
  "Adaptability to Pressure",
  "Self-Learner",
  "Collaborative Team Player",
  "Java",
  "Python",
  "C",
  "JavaScript",
  "CSS",
  "HTML",
  "PHP",
  "Sass",
  "Verilog HDL",
  "VHDL",
  "React",
  "React-Native",
  "Linux",
  "MATLAB",
  "Microsoft Office",
];

const Experiences = [
  {
    id: 1,
    imageSrc: require("../assets/logo1-Custom.jpg"),
    title: "Progineer Technologies",
    job: "Backend-Database ",
    description: [
      "Developed a strong understanding of databases and their performance characteristics, with a focus on Oracle, Cassandra, and MongoDB",
      "Explored the differences between the three databases in terms of performance and best use cases, enabling informed decision making for data storage solutions",
      "Built a user-friendly GUI using Python to interact with the databases•",
      "Gained practical knowledge in Oracle statistics and their role in performance tuning, contributing to the optimization of database operations.",
    ],
  },
  // Add more card data as needed
  {
    id: 2,
    imageSrc: require("../assets/ealb-logo.png"),
    title: "Egyptian Arab Land Bank",
    job: "Help Desk",
    description: [
      "In my capacity as a help desk specialist, I actively resolve banking issues, tackling challenges such as stuck check incidents and erroneous transactions. Proficient in Oracle database management, I adeptly modify the database for user management, ensuring the robust integrity of the system.",
      "I play role in enhancing system functionality by developing comprehensive reports, writing queries, and rigorously testing changes. Ongoing training in report and form creation continually sharpens and expands my database management capabilities.",
      "My command of programming languages actively fuels collaboration with development teams, empowering the seamless implementation of changes aligned with industry standards.",
    ],
  },

  // Add more cards as needed
];

const MyLanguages = [
  {
    name: "Arabic",
    level: "Native",
    width: "95%",
    description:
      "Fluent in Arabic, my native language, I possess a deep understanding of its nuances, cultural context, and linguistic intricacies. From the eloquent verses of classical poetry to the contemporary vernacular expressions, my grasp of Arabic extends beyond mere communication to a profound connection with the heritage and history embedded within the language. With the ability to navigate diverse dialects, I effortlessly engage in conversations, embracing the rich tapestry of expressions that define Arabic discourse. My linguistic proficiency allows me to appreciate not only the language's practical utility but also its aesthetic beauty, encapsulating the essence of a vibrant and multifaceted culture.",
  },
  {
    name: "English",
    level: "Professional",
    width: "89%",
    description:
      "Proficient in English, I have honed my language skills to a professional level through dedicated academic endeavors and practical application in various professional settings. While English may not be my native language, I have successfully navigated the challenges of academia and leveraged its use across diverse online and professional platforms. My adeptness in English extends beyond basic communication; it is a professional asset that allows me to navigate complex subjects, contribute effectively to team dynamics, and articulate ideas with precision and clarity. This proficiency reflects a deliberate and strategic use of the English language, enhancing my professional capabilities and facilitating seamless interaction in academic and work environments.",
  },
];
// export default projects

const Educations = [
  {
    name: "Bachalor in Computer Engineering",
    location: "Birzeit Univercity",
    date: "2018-2023",
    achievement: "Honor List recognition",
    description: [
      "Developed a strong foundation in computer engineering principles, including hardware design, software development, and system analysis",
      "Acquired hands-on experience in programming languages such as C,Java,Python,Assembly, enhancing problem-solving skills and algorithmic thinking.",
      "Completed a range of projects that demonstrated proficiency in areas such as arduino and pic microcontroller hardware project in c, cpu scheduling system in java, assembly and python projects",
      "Engaged in collaborative coursework, fostering teamwork and effective communication within multidisciplinary projects.",
      "Gained a comprehensive understanding of computer networks, digital systems, and embedded systems.",
      "Demonstrated adaptability and a commitment to excellence ",
    ],
  },
  {
    name: "High School",
    location: "Salfit",
    date: "-2018",
    achievement: "finished high school first on class with a grade of 98.9%",
    description: [
      "Excelled in a diverse range of subjects, showcasing a strong academic aptitude.",
      "Demonstrated consistent dedication to academic excellence and a passion for learning.",
    ],
  },
];

const Aboutme = [
  "Enthusiastic and forward-thinking Computer Engineering graduate with a passion for turning ideas into tangible solutions. I thrive on the intersection of hardware and software, where creativity meets functionality.",

  "My journey is marked by a commitment to excellence, reflected in my recognition on the Honor List. Beyond the classroom, I've immersed myself in diverse projects, from hardware design to system analysis, showcasing adaptability and a keen problem-solving mindset.",

  "In professional settings, I've navigated the complexities of databases and user-centric challenges, honing my skills in backend development and help desk support.",

  "Fluent in both Arabic and English, I bring a global perspective to my work. My ability to seamlessly transition between languages extends to my coding, where each line is a bridge between ideas and execution.",

  "Excited to contribute my technical expertise and collaborative spirit to innovative projects. Let's explore the possibilities!",
];

export default About;

const technicalSkills = [
  { name: "Java", level: 85 },
  { name: "Python", level: 95 },
  { name: "C", level: 85 },
  { name: "JavaScript", level: 87 },
  { name: "CSS", level: 90 },
  { name: "HTML", level: 95 },
  { name: "Sass", level: 85 },
  { name: "Node", level: 80 },
  { name: "PHP", level: 83 },
  { name: "VHDL", level: 80 },
  { name: "React", level: 85 },
  { name: "React-Native", level: 83 },
  { name: "Linux", level: 88 },
];

const personalSkills = [
  { name: "Diligent Work Ethic", level: 95 },
  { name: "Adaptability to Pressure", level: 96 },
  { name: "Self-Learner", level: 99 },
  { name: "Collaborative Team Player", level: 95 },
  { name: "Creative Thinking", level: 95 },
];

const softwareSkills = [
  { name: "MATLAB", level: 78 },
  { name: "Microsoft Office", level: 93 },
  { name: "PhotoShop", level: 91 },
];

export { technicalSkills, personalSkills, softwareSkills };

export { skills, projects, Experiences, Aboutme, MyLanguages, Educations };
